
namespace RecordShield.Workspace {
    
    @Serenity.Decorators.registerClass()
    export class ProductsGrid extends Serenity.EntityGrid<ProductsRow, any> {
        protected getColumnsKey() { return 'Workspace.Products'; }
        protected getDialogType() { return ProductsDialog; }
        protected getIdProperty() { return ProductsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductsRow.localTextPrefix; }
        protected getService() { return ProductsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons(): Serenity.ToolButton[] {

            // call base method to get list of buttons
            // by default, base entity grid adds a few buttons, 
            // add, refresh, column selection in order.
            var buttons = super.getButtons();

            // here is several methods to remove add button
            // only one is enabled, others are commented

            // METHOD 1
            // we would be able to simply return an empty button list,
            // but this would also remove all other buttons
            // return [];

            // METHOD 2
            // remove by splicing (something like delete by index)
            // here we hard code add button index (not nice!)
            // buttons.splice(0, 1);

            // METHOD 3 - recommended
            // remove by splicing, but this time find button index
            // by its css class. it is the best and safer method

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            if (Authorization.hasPermission('Workspace:Application')) {
                buttons.push({
                    title: 'Import From Excel',
                    cssClass: 'export-xlsx-button',
                    onClick: () => {
                        debugger;
                        // open import dialog, let it handle rest
                        var dialog = new ProductExcelImportDialog();
                        dialog.element.on('dialogclose', () => {
                            this.refresh();
                            dialog = null;
                        });
                        dialog.dialogOpen();
                    }
                });
                buttons.push({
                    title: 'Import Product Items',
                    cssClass: 'export-xlsx-button',
                    onClick: () => {
                        debugger;
                        // open import dialog, let it handle rest
                        var dialog = new ProductItemsExcelImportDialog();
                        dialog.element.on('dialogclose', () => {
                            this.refresh();
                            dialog = null;
                        });
                        dialog.dialogOpen();
                    }
                });
            }
            buttons.push(RecordShield.Common.ExcelExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                service: 'Workspace/Products/ListExcel',
                separator: true
            }));

            buttons.push(RecordShield.Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit()
            }));

            return buttons;
        }

        protected onViewProcessData(response: Serenity.ListResponse<ProductsRow>) {
            response = super.onViewProcessData(response);
            debugger;
           // var map: { [ProductName: string]: number; } = {};
            // there is no __id property in CustomerGrossSalesRow but 
            // this is javascript and we can set any property of an object
            //for (var x of response.Entities) {
            //    var statusId = response.Entities.length;
            //    var statusName = "TotalProduct";
               
            //    map[statusName] = (map[statusName] + 1)
            //}
            var htmlString = 'Total Products-' + response.Entities.length;
            //for (var key in map) {
            //    var value = map[key];
            //    htmlString += key + ' - ' + map[key] + ', ';
            //}
            $("#divStatusDetails")[0].innerHTML = htmlString;
            return response;
        }
    }
}